/**
 * Our state store
 * @module Store
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from "vue";
import Vuex from "vuex";
import * as Devices from "../device";
import * as Peers from "../peers";
import * as Utils from "../utils";
import chatStore from "./chat";
Vue.use(Vuex);
var store = new Vuex.Store({
    modules: {
        chat: chatStore,
    },
    state: {
        appState: "pure",
        errors: {
            fatal: null,
            minor: undefined,
            device: undefined,
            audioDevice: {
                errorId: undefined,
                deviceName: undefined,
            },
            videoDevice: {
                errorId: undefined,
                deviceName: undefined,
            },
        },
        devices: {
            video: [],
            audio: [],
            current: {
                video: null,
                audio: null,
            },
        },
        streams: {
            local: null,
            updated: false,
        },
        localScreenStream: null,
        defaultLocalUserName: "You",
        localUserName: "You",
        peers: [],
        screenShareError: null,
        sharingScreenAndVideo: false,
        bitrateLimitPeerCount: 0,
        videoFlipped: false,
        audioProcessingDisabled: false,
        supportMusic: false,
        localAudioEnabled: true,
        supportSimultaneousScreen: false,
        screenTallyActive: false,
    },
    getters: {
        appState: function (state) {
            return state.appState;
        },
        fatalError: function (state) {
            return state.errors.fatal;
        },
        minorError: function (state) {
            return state.errors.minor;
        },
        deviceError: function (state) {
            return state.errors.device;
        },
        audioDeviceError: function (state) {
            return state.errors.audioDevice;
        },
        videoDeviceError: function (state) {
            return state.errors.videoDevice;
        },
        videoDevices: function (state) {
            return state.devices.video;
        },
        audioDevices: function (state) {
            return state.devices.audio;
        },
        currentVideoDevice: function (state) {
            return state.devices.current.video;
        },
        currentAudioDevice: function (state) {
            return state.devices.current.audio;
        },
        preferredVideoDevice: function () {
            return Devices.getPreferredDevices().videoDeviceId;
        },
        preferredAudioDevice: function () {
            return Devices.getPreferredDevices().audioDeviceId;
        },
        localStream: function (state) {
            return state.streams.local;
        },
        localStreamUpdated: function (state) {
            return state.streams.updated;
        },
        localScreenStream: function (state) {
            return state.localScreenStream;
        },
        defaultLocalUserName: function (state) {
            return state.defaultLocalUserName;
        },
        localUserName: function (state) {
            return state.localUserName;
        },
        peers: function (state) {
            return __spreadArrays(state.peers);
        },
        screenShareError: function (state) {
            return state.screenShareError;
        },
        sharingScreenAndVideo: function (state) {
            return state.sharingScreenAndVideo;
        },
        sharingScreenOnly: function (state) {
            if (state.devices.current.video) {
                return state.devices.current.video.deviceId === "screen";
            }
            return false;
        },
        bitrateLimitPeerCount: function (state) {
            return state.bitrateLimitPeerCount;
        },
        videoFlipped: function (state) {
            return state.videoFlipped;
        },
        audioProcessingDisabled: function (state) {
            return state.audioProcessingDisabled;
        },
        supportMusic: function (state) {
            return state.supportMusic;
        },
        localAudioEnabled: function (state) {
            return state.localAudioEnabled;
        },
        supportSimultaneousScreen: function (state) {
            return state.supportSimultaneousScreen;
        },
        supportScreensharing: function () {
            return navigator.mediaDevices && "getDisplayMedia" in navigator.mediaDevices;
        },
        screenTallyActive: function (state) {
            return state.screenTallyActive;
        },
    },
    mutations: {
        appState: function (state, newState) {
            state.appState = newState;
        },
        fatalError: function (state, errorId) {
            state.errors.fatal = errorId;
        },
        minorError: function (state, error) {
            state.errors.minor = error;
        },
        deviceError: function (state, error) {
            state.errors.device = error;
        },
        audioDeviceError: function (state, error) {
            state.errors.audioDevice.errorId = error.errorId;
            state.errors.audioDevice.deviceName = error.deviceName;
        },
        videoDeviceError: function (state, error) {
            state.errors.videoDevice.errorId = error.errorId;
            state.errors.videoDevice.deviceName = error.deviceName;
        },
        videoDevices: function (state, devices) {
            state.devices.video = devices;
        },
        audioDevices: function (state, devices) {
            state.devices.audio = devices;
        },
        currentVideoDevice: function (state, device) {
            state.devices.current.video = device;
        },
        currentAudioDevice: function (state, device) {
            state.devices.current.audio = device;
        },
        localStream: function (state, stream) {
            state.streams.local = stream;
            state.streams.updated = true;
        },
        localStreamUpdated: function (state, updated) {
            state.streams.updated = updated;
        },
        localScreenStream: function (state, screenStream) {
            state.localScreenStream = screenStream;
        },
        preferredVideoDevice: function (_, deviceId) {
            Devices.setPreferredDevices({ video: deviceId });
        },
        preferredAudioDevice: function (_, deviceId) {
            Devices.setPreferredDevices({ audio: deviceId });
        },
        localUserName: function (state, newName) {
            state.localUserName = newName;
        },
        peers: function (state, peers) {
            state.peers = peers;
        },
        screenShareError: function (state, val) {
            state.screenShareError = val;
        },
        sharingScreenAndVideo: function (state, newValue) {
            state.sharingScreenAndVideo = newValue;
        },
        bitrateLimitPeerCount: function (state, newValue) {
            state.bitrateLimitPeerCount = newValue;
        },
        videoFlipped: function (state, newValue) {
            state.videoFlipped = newValue;
        },
        audioProcessingDisabled: function (state, newValue) {
            state.audioProcessingDisabled = newValue;
        },
        supportMusic: function (state, newValue) {
            state.supportMusic = newValue;
        },
        localAudioEnabled: function (state, newValue) {
            state.localAudioEnabled = newValue;
        },
        supportSimultaneousScreen: function (state, newValue) {
            state.supportSimultaneousScreen = newValue;
        },
        screenTallyActive: function (state, newValue) {
            state.screenTallyActive = newValue;
        },
    },
    actions: {
        updateAppState: function (_a, newState) {
            var commit = _a.commit;
            commit("appState", newState);
        },
        setFatalError: function (_a, errorId) {
            var commit = _a.commit;
            commit("fatalError", errorId);
        },
        setMinorError: function (_a, error) {
            var commit = _a.commit;
            commit("minorError", error);
        },
        setDeviceError: function (_a, error) {
            var commit = _a.commit;
            commit("deviceError", error);
        },
        setAudioDeviceError: function (_a, error) {
            var commit = _a.commit;
            commit("audioDeviceError", error);
        },
        setVideoDeviceError: function (_a, error) {
            var commit = _a.commit;
            commit("videoDeviceError", error);
        },
        setScreenShareError: function (_a, error) {
            var commit = _a.commit;
            commit("screenShareError", error);
        },
        setLocalScreenStream: function (_a, screenStream) {
            var commit = _a.commit;
            commit("localScreenStream", screenStream);
        },
        loadInputDevices: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var devices, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, Devices.getInputDevices()];
                        case 1:
                            devices = _b.sent();
                            commit("audioDevices", Devices.filterDevicesByKind("audio", devices));
                            commit("videoDevices", Devices.filterDevicesByKind("video", devices));
                            dispatch("setDeviceError", undefined);
                            if (state.streams.local == null) {
                                if (devices.length) {
                                    commit("localStream", new MediaStream());
                                }
                                else {
                                    dispatch("setDeviceError", "NO_DEVICES");
                                }
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            if (error_1.name == "NotAllowedError") {
                                dispatch("setDeviceError", "NOT_ALLOWED");
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        updateCurrentVideoDevice: function (_a, device) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            var previousDevice = state.devices.current.video;
            commit("currentVideoDevice", device);
            dispatch("updateLocalVideoTrack", previousDevice);
            if (device && device.deviceId && device.deviceId !== "screen") {
                dispatch("preferredVideoDevice", device.deviceId);
            }
        },
        updateCurrentAudioDevice: function (_a, device) {
            var commit = _a.commit, dispatch = _a.dispatch;
            commit("currentAudioDevice", device);
            dispatch("updateLocalAudioTrack");
            if (device && device.deviceId) {
                dispatch("preferredAudioDevice", device.deviceId);
            }
        },
        updateLocalAudioTrack: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var audioDevice, audioProcessingDisabled, catchAudioDeviceError, getAudioTrack, currentStream, audioTrack;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            audioDevice = state.devices.current.audio || { deviceId: undefined };
                            audioProcessingDisabled = state.audioProcessingDisabled;
                            catchAudioDeviceError = function (error, deviceName) {
                                commit("currentAudioDevice", { deviceId: undefined });
                                if (error.name === "NotAllowedError") {
                                    dispatch("setAudioDeviceError", { errorId: "NOT_ALLOWED", deviceName: deviceName });
                                    return;
                                }
                                dispatch("setAudioDeviceError", { errorId: "NOT_READABLE_DEVICE", deviceName: deviceName });
                            };
                            getAudioTrack = function () { return __awaiter(_this, void 0, void 0, function () {
                                var error_2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, Devices.getAudioTrackForDevice(audioDevice, audioProcessingDisabled)];
                                        case 1: return [2 /*return*/, _a.sent()];
                                        case 2:
                                            error_2 = _a.sent();
                                            catchAudioDeviceError(error_2, audioDevice.label);
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); };
                            currentStream = state.streams.local;
                            if (currentStream) {
                                if (currentStream.getAudioTracks()[0]) {
                                    currentStream.getAudioTracks()[0].stop();
                                }
                            }
                            return [4 /*yield*/, getAudioTrack()];
                        case 1:
                            audioTrack = _b.sent();
                            currentStream = state.streams.local;
                            if (currentStream) {
                                if (currentStream.getAudioTracks()[0]) {
                                    currentStream.getAudioTracks()[0].stop();
                                    currentStream.removeTrack(currentStream.getAudioTracks()[0]);
                                }
                            }
                            if (audioTrack) {
                                currentStream.addTrack(audioTrack);
                            }
                            commit("localStream", currentStream);
                            dispatch("updatePeerAudioTracks");
                            return [2 /*return*/];
                    }
                });
            });
        },
        updateLocalVideoTrack: function (_a, previousDevice) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var videoDevice, isVideoDeviceScreen, catchVideoDeviceError, getVideoTrack, getScreenSharingTrack, videoTrack, currentStream;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            videoDevice = state.devices.current.video || { deviceId: undefined };
                            isVideoDeviceScreen = function () {
                                return videoDevice.deviceId === "screen";
                            };
                            catchVideoDeviceError = function (error, deviceName) {
                                commit("currentVideoDevice", { deviceId: undefined });
                                if (error.name === "NotAllowedError") {
                                    dispatch("setVideoDeviceError", { errorId: "NOT_ALLOWED", deviceName: deviceName });
                                    return;
                                }
                                dispatch("setVideoDeviceError", { errorId: "NOT_READABLE_DEVICE", deviceName: deviceName });
                            };
                            getVideoTrack = function () { return __awaiter(_this, void 0, void 0, function () {
                                var error_3;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, Devices.getVideoTrackForDevice(videoDevice)];
                                        case 1: return [2 /*return*/, _a.sent()];
                                        case 2:
                                            error_3 = _a.sent();
                                            catchVideoDeviceError(error_3, videoDevice.label);
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); };
                            getScreenSharingTrack = function () {
                                var localScreenStream = state.localScreenStream;
                                if (localScreenStream && localScreenStream.getVideoTracks()[0]) {
                                    return localScreenStream.getVideoTracks()[0];
                                }
                                return null;
                            };
                            if (!isVideoDeviceScreen()) return [3 /*break*/, 1];
                            videoTrack = getScreenSharingTrack();
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, getVideoTrack()];
                        case 2:
                            videoTrack = _b.sent();
                            _b.label = 3;
                        case 3:
                            currentStream = state.streams.local;
                            if (currentStream) {
                                if (currentStream.getVideoTracks()[0]) {
                                    if (previousDevice.deviceId !== "screen") {
                                        currentStream.getVideoTracks()[0].stop();
                                    }
                                    currentStream.removeTrack(currentStream.getVideoTracks()[0]);
                                }
                            }
                            if (!videoTrack) {
                                return [2 /*return*/];
                            }
                            // Stop dummy track as we have real one now.
                            Utils.stopDummyVideoTrack();
                            currentStream.addTrack(videoTrack);
                            commit("localStream", currentStream);
                            dispatch("updatePeerVideoTracks");
                            return [2 /*return*/];
                    }
                });
            });
        },
        updatePeerAudioTracks: function (_a) {
            var state = _a.state;
            var peers = state.peers;
            var stream = state.streams.local;
            var audioProcessingDisabled = state.audioProcessingDisabled;
            peers.forEach(function (peer) {
                if (peer.isLocal)
                    return;
                Peers.updateAudioTransceiver(peer, stream, audioProcessingDisabled);
            });
        },
        updatePeerVideoTracks: function (_a) {
            var state = _a.state;
            var peers = state.peers;
            var stream = state.streams.local;
            peers.forEach(function (peer) {
                if (peer.isLocal)
                    return;
                Peers.updateVideoTransceiver(peer, stream);
            });
        },
        preferredVideoDevice: function (_a, deviceId) {
            var commit = _a.commit;
            commit("preferredVideoDevice", deviceId);
        },
        preferredAudioDevice: function (_a, deviceId) {
            var commit = _a.commit;
            commit("preferredAudioDevice", deviceId);
        },
        updateLocalUserName: function (_a, newName) {
            var commit = _a.commit;
            commit("localUserName", newName);
        },
        removePeer: function (_a, peer) {
            var commit = _a.commit, state = _a.state;
            var peers = state.peers;
            commit("peers", peers.filter(function (item) { return item.identifier !== peer.identifier; }));
        },
        addPeer: function (_a, peer) {
            var state = _a.state;
            var peers = state.peers;
            peers.push(peer);
        },
        clearPeers: function (_a) {
            var commit = _a.commit;
            commit("peers", []);
        },
        updateSharingScreenAndVideo: function (_a, newValue) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var stream, currentVideoDevice, peers;
                return __generator(this, function (_b) {
                    commit("sharingScreenAndVideo", newValue);
                    stream = null;
                    if (newValue) {
                        stream = state.localScreenStream;
                    }
                    currentVideoDevice = state.devices.current.video;
                    if (currentVideoDevice.deviceId === "screen" && state.sharingScreenAndVideo) {
                        dispatch("updateCurrentVideoDevice", { deviceId: undefined });
                    }
                    peers = state.peers;
                    peers.forEach(function (peer) {
                        if (peer.isLocal)
                            return;
                        Peers.updateScreenshareTransceiver(peer, stream, state.sharingScreenAndVideo);
                    });
                    return [2 /*return*/];
                });
            });
        },
        bitrateLimitPeerCount: function (_a, newValue) {
            var commit = _a.commit;
            commit("bitrateLimitPeerCount", newValue);
        },
        updateVideoFlipped: function (_a, newValue) {
            var commit = _a.commit;
            commit("videoFlipped", newValue);
        },
        updateAudioProcessingDisabled: function (_a, newValue) {
            var commit = _a.commit, dispatch = _a.dispatch;
            commit("audioProcessingDisabled", newValue);
            dispatch("updateLocalAudioTrack");
        },
        updateSupportMusic: function (_a, newValue) {
            var commit = _a.commit;
            commit("supportMusic", newValue);
        },
        updateLocalAudioEnabled: function (_a, newValue) {
            var commit = _a.commit;
            commit("localAudioEnabled", newValue);
        },
        updateSupportSimultaneousScreen: function (_a, newValue) {
            var commit = _a.commit;
            commit("supportSimultaneousScreen", newValue);
        },
        updateScreenTallyActive: function (_a, newValue) {
            var commit = _a.commit;
            commit("screenTallyActive", newValue);
        }
    },
});
export default store;



//////////////////
// WEBPACK FOOTER
// ./src/store/index.ts
// module id = 139
// module chunks = 1